// Single source of truth for page "last updated" dates (YYYY-MM-DD).
// Used by /sitemap.xml <lastmod>, JSON-LD dateModified/datePublished and the
// visible "Last updated" line. Update a page's updatedAt only when its main
// content changes (body text, headings, FAQs, prices shown, tables/sections).
export type PageDate = { updatedAt: string; publishedAt?: string };

export const pageDates: Record<string, PageDate> = {
  "/": { updatedAt: "2026-10-31" },
  "/services": { updatedAt: "2026-10-19" },
  "/practice-areas": { updatedAt: "2026-06-20" },
  "/best-law-firm-seo-companies": { updatedAt: "2026-10-28" },
  "/case-studies": { updatedAt: "2026-06-24" },
  "/pricing": { updatedAt: "2026-10-19" },
  "/law-firm-seo-audit": { updatedAt: "2026-10-15" },
  "/blog": { updatedAt: "2026-10-22" },
  "/lawyer-seo": { updatedAt: "2026-06-15" },
  "/guides": { updatedAt: "2026-05-05" },
  "/about": { updatedAt: "2026-03-14" },
  "/contact": { updatedAt: "2026-03-14" },
  "/uk/seo-for-solicitors": { updatedAt: "2026-10-28" },
  "/uk/local-seo-for-solicitors": { updatedAt: "2026-10-28" },
  "/uk/digital-marketing-for-solicitors": { updatedAt: "2026-10-28" },
  "/services/law-firm-seo": { updatedAt: "2026-10-21" },
  "/services/local-seo-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/ai-seo-geo": { updatedAt: "2026-10-19" },
  "/services/law-firm-website-development": { updatedAt: "2026-10-19" },
  "/services/legal-content-writing": { updatedAt: "2026-10-19" },
  "/services/link-building-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/ppc-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/technical-seo-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/lead-generation-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/social-media-marketing-for-law-firms": { updatedAt: "2026-10-19" },
  "/services/law-firm-marketing-analytics": { updatedAt: "2026-10-19" },
  "/practice-areas/personal-injury-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/dui-dwi-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/family-law-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/criminal-defense-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/estate-planning-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/immigration-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/bankruptcy-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/employment-law-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/workers-compensation-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/tax-law-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/medical-malpractice-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/real-estate-law-lawyer-seo": { updatedAt: "2026-10-19" },
  "/practice-areas/corporate-business-lawyer-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/las-vegas-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/scottsdale-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/minneapolis-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/kansas-city-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/baltimore-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/charlotte-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/nashville-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/arizona-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/arkansas-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/atlanta-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/austin-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/boston-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/chicago-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/cleveland-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/connecticut-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/dallas-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/delaware-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/denver-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/florida-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/fresno-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/georgia-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/houston-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/illinois-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/indiana-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/iowa-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/jacksonville-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/kansas-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/long-island-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/los-angeles-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/louisiana-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/maryland-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/miami-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/michigan-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/minnesota-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/montana-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/nevada-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/new-hampshire-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/new-mexico-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/new-york-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/north-carolina-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/north-dakota-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/ohio-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/orlando-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/pennsylvania-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/peoria-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/philadelphia-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/phoenix-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/portland-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/sacramento-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/san-antonio-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/san-bernardino-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/san-diego-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/san-francisco-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/santa-ana-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/seattle-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/south-carolina-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/stockton-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/tampa-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/tennessee-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/texas-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/tucson-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/tulsa-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/ventura-county-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/vermont-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/virginia-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/washington-dc-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/west-virginia-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/wisconsin-seo": { updatedAt: "2026-10-19" },
  "/lawyer-seo/wyoming-seo": { updatedAt: "2026-10-19" },
  "/case-studies/personal-injury-houston": { updatedAt: "2026-10-12" },
  "/case-studies/dui-defense-phoenix": { updatedAt: "2026-10-12" },
  "/case-studies/family-law-chicago": { updatedAt: "2026-10-12" },
  "/case-studies/estate-planning-boston": { updatedAt: "2026-10-12" },
  "/glossary": { updatedAt: "2026-09-26" },
  "/glossary/local-pack": { updatedAt: "2026-09-26" },
  "/glossary/google-business-profile": { updatedAt: "2026-09-26" },
  "/glossary/nap-consistency": { updatedAt: "2026-09-26" },
  "/glossary/local-citations": { updatedAt: "2026-09-26" },
  "/glossary/review-velocity": { updatedAt: "2026-09-26" },
  "/glossary/crawl-budget": { updatedAt: "2026-09-26" },
  "/glossary/indexing": { updatedAt: "2026-09-26" },
  "/glossary/core-web-vitals": { updatedAt: "2026-09-26" },
  "/glossary/canonical-tag": { updatedAt: "2026-09-26" },
  "/glossary/schema-markup": { updatedAt: "2026-09-26" },
  "/glossary/legalservice-schema": { updatedAt: "2026-09-26" },
  "/glossary/practice-area-page": { updatedAt: "2026-09-26" },
  "/glossary/e-e-a-t": { updatedAt: "2026-09-26" },
  "/glossary/ymyl": { updatedAt: "2026-09-26" },
  "/glossary/search-intent": { updatedAt: "2026-09-26" },
  "/glossary/topic-cluster": { updatedAt: "2026-09-26" },
  "/glossary/content-pruning": { updatedAt: "2026-09-26" },
  "/glossary/backlink": { updatedAt: "2026-09-26" },
  "/glossary/anchor-text": { updatedAt: "2026-09-26" },
  "/glossary/pbn": { updatedAt: "2026-09-26" },
  "/glossary/domain-authority": { updatedAt: "2026-09-26" },
  "/glossary/unlinked-mention": { updatedAt: "2026-09-26" },
  "/glossary/geo": { updatedAt: "2026-09-26" },
  "/glossary/ai-overviews": { updatedAt: "2026-09-26" },
  "/glossary/llm-citation": { updatedAt: "2026-09-26" },
  "/glossary/entity-seo": { updatedAt: "2026-09-26" },
  "/glossary/llms-txt": { updatedAt: "2026-09-26" },
  "/glossary/local-services-ads": { updatedAt: "2026-09-26" },
  "/glossary/cost-per-click": { updatedAt: "2026-09-26" },
  "/glossary/quality-score": { updatedAt: "2026-09-26" },
  "/glossary/cost-per-case": { updatedAt: "2026-09-26" },
  "/glossary/intake-conversion-rate": { updatedAt: "2026-09-26" },
  "/glossary/call-tracking": { updatedAt: "2026-09-26" },
  "/glossary/ga4-key-event": { updatedAt: "2026-09-26" },
  "/glossary/aba-model-rule-7-1": { updatedAt: "2026-09-26" },
  "/glossary/attorney-advertising-disclaimer": { updatedAt: "2026-09-26" },
  "/glossary/client-testimonial-rules": { updatedAt: "2026-09-26" },
  "/blog/law-firm-performance-metrics": { updatedAt: "2026-10-22", publishedAt: "2026-10-22" },
  "/blog/social-media-scheduling-tools-for-law-firms": { updatedAt: "2026-10-22", publishedAt: "2026-10-22" },
  "/blog/who-can-manage-google-business-profile-for-law-firm": { updatedAt: "2026-10-15", publishedAt: "2026-10-15" },
  "/blog/how-to-use-technology-to-improve-legal-marketing": { updatedAt: "2026-10-13", publishedAt: "2026-10-13" },
  "/blog/how-to-measure-roi-on-law-firm-marketing": { updatedAt: "2026-10-13", publishedAt: "2026-10-13" },
  "/blog/how-to-generate-leads-for-law-firms": { updatedAt: "2026-10-13", publishedAt: "2026-10-13" },
  "/blog/how-law-firms-get-found-on-chatgpt": { updatedAt: "2026-10-13", publishedAt: "2026-10-13" },
  "/blog/can-seo-help-law-firms-generate-more-leads": { updatedAt: "2026-10-07", publishedAt: "2026-09-25" },
  "/blog/why-does-seo-for-personal-injury-lawyers-matter": { updatedAt: "2026-10-07", publishedAt: "2026-09-10" },
  "/blog/law-firm-seo-strategy": { updatedAt: "2026-10-07", publishedAt: "2026-02-14" },
  "/blog/dui-lawyer-seo-guide": { updatedAt: "2026-05-18", publishedAt: "2026-01-22" },
  "/blog/solo-lawyer-small-firm-seo": { updatedAt: "2026-06-10", publishedAt: "2026-02-01" },
  "/blog/law-firm-seo-tips": { updatedAt: "2026-10-07", publishedAt: "2026-03-04" },
  "/blog/best-law-firm-seo-tools": { updatedAt: "2026-06-25", publishedAt: "2026-02-18" },
  "/blog/on-page-seo-for-lawyers": { updatedAt: "2026-06-08", publishedAt: "2026-02-25" },
  "/blog/law-firm-seo-statistics-trends": { updatedAt: "2026-06-28", publishedAt: "2026-01-05" },
  "/blog/keyword-research-for-law-firms": { updatedAt: "2026-06-14", publishedAt: "2026-02-11" },
  "/blog/how-to-choose-law-firm-seo-agency": { updatedAt: "2026-06-30", publishedAt: "2026-03-11" },
  "/blog/top-geo-agencies-for-law-firms": { updatedAt: "2026-10-07", publishedAt: "2026-07-16" },
  "/blog/how-law-firms-turn-seo-traffic-into-new-clients": { updatedAt: "2026-10-07", publishedAt: "2026-09-26" },
};

export function normalizePath(path: string): string {
  const clean = path.split(/[?#]/)[0] || "/";
  return clean.length > 1 ? clean.replace(/\/+$/, "") : "/";
}

export function getPageDate(path: string): PageDate | undefined {
  return pageDates[normalizePath(path)];
}

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** "2026-11-01" -> "November 1, 2026" (timezone independent). */
export function formatPageDate(iso: string): string {
  const [y, m, d] = iso.split("-").map(Number);
  return `${MONTHS[m - 1]} ${d}, ${y}`;
}

const DATED_TYPES = new Set(["WebPage", "CollectionPage", "AboutPage", "ContactPage", "ItemPage", "Article", "BlogPosting", "NewsArticle", "TechArticle", "Service"]);

/** Sets dateModified/datePublished on WebPage, Article, BlogPosting and Service nodes. */
export function applyDatesToSchema(value: unknown, date: PageDate): unknown {
  if (Array.isArray(value)) return value.map((v) => applyDatesToSchema(v, date));
  if (value === null || typeof value !== "object") return value;
  const record = value as Record<string, unknown>;
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(record)) out[k] = k === "@graph" ? applyDatesToSchema(v, date) : v;
  const types = Array.isArray(record["@type"]) ? record["@type"] : [record["@type"]];
  if (types.some((t) => typeof t === "string" && DATED_TYPES.has(t))) {
    if (date.publishedAt) out.datePublished = date.publishedAt;
    out.dateModified = date.updatedAt;
  }
  return out;
}

type HeadScript = { type?: string; children?: string; [key: string]: unknown };

export function applyDatesToScripts<T extends HeadScript>(path: string, scripts: T[] | undefined): T[] | undefined {
  const date = getPageDate(path);
  if (!date || !scripts) return scripts;
  return scripts.map((s) => {
    if (s?.type !== "application/ld+json" || typeof s.children !== "string") return s;
    try {
      return { ...s, children: JSON.stringify(applyDatesToSchema(JSON.parse(s.children), date)) };
    } catch {
      return s;
    }
  });
}
